module.exports = __webpack_public_path__ + "static/media/space-food_005.0379eb88.jpg";